import React, { lazy, Suspense } from 'react';
import { ErrorProps } from './ErrorInner';

const ErrorInner = lazy(() => import('./ErrorInner'));

const Error = ({ resetError, showMeta = true }: ErrorProps) => {
  return (
    <Suspense>
      <ErrorInner resetError={resetError} showMeta={showMeta} />
    </Suspense>
  );
};

export default Error;
